import { render } from "./SettingsChangePasswordSection.vue?vue&type=template&id=68082277"
import script from "./SettingsChangePasswordSection.vue?vue&type=script&lang=js"
export * from "./SettingsChangePasswordSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__